import { render, staticRenderFns } from "./ModalVettingForm.vue?vue&type=template&id=d4fb07f2&scoped=true"
import script from "./ModalVettingForm.vue?vue&type=script&lang=js"
export * from "./ModalVettingForm.vue?vue&type=script&lang=js"
import style0 from "./ModalVettingForm.vue?vue&type=style&index=0&id=d4fb07f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4fb07f2",
  null
  
)

export default component.exports